<template>
  <div>
    <div class="product3">
      <div class="productBanner">
        <div class="module">
          <div class="h1">ZTMap3D</div>
          <div class="line"></div>
          <div class="h2">GIS+BIM三维融合渲染平台</div>
          <div class="p">实现多架构的三维模型实时渲染基于最新的前端绘图技术开发解决三维渲染跨平台兼容性</div>
        </div>
        <div class="img"></div>
      </div>
      <div class="overview">
        <div class="module">
          <div class="productTitle">
            概述
            <span>/Overview</span>
          </div>
          <div
            class="p"
          >臻图ZTMap系列轻量化三维融合渲染平台，实现了宏观二三维GIS地理信息、微观建筑物室内BIM模型的统一集成渲染和无缝漫游体验。创新的轻量化设计理念和开发架构，解决了从宏观到微观海量三维模型数据的加载和渲染效率难题，实现了空间数据的渐进加载和极速渲染功能，提供了良好的用户体验。该产品简便易用的交互式二次开发接口和可视化工具，极大缩短了三维可视化应用开发的周期、降低了可视化应用开发的门槛和成本。</div>
        </div>
      </div>
      <div class="function">
        <div class="productTitle">
          功能简介
          <span>/Function</span>
        </div>
        <div class="functionbg">
          <div class="module">
            <div class="list">
              <div>
                <div class="left">01</div>
                <div class="right">
                  <div class="title">GIS二三维数据渲染支持</div>
                </div>
              </div>
              <div>
                <div class="left">02</div>
                <div class="right">
                  <div class="title">BIM数据渲染支持</div>
                </div>
              </div>
              <div>
                <div class="left">03</div>
                <div class="right">
                  <div class="title">GIS+BIM场景融合渲染</div>
                </div>
              </div>
              <div>
                <div class="left">04</div>
                <div class="right">
                  <div class="title">海量三维数据极速渲染</div>
                </div>
              </div>
              <div>
                <div class="left">05</div>
                <div class="right">
                  <div class="title">地理坐标&BIM坐标转换</div>
                </div>
              </div>
              <div>
                <div class="left">06</div>
                <div class="right">
                  <div class="title">GIS+BIM空间分析</div>
                </div>
              </div>
              <div>
                <div class="left">07</div>
                <div class="right">
                  <div class="title">三维特效模块组</div>
                </div>
              </div>
              <div>
                <div class="left">08</div>
                <div class="right">
                  <div class="title">可视化交互式开发工具</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="rendering">
        <div class="module">
          <div class="productTitle">
            效果图
            <span>/Rendering</span>
          </div>
          <div class="list">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <!-- <div></div> -->
          </div>
        </div>
      </div>
      <div class="characteristics">
        <div class="module">
          <div class="productTitle">
            技术特点
            <span>/Characteristics</span>
          </div>
          <div class="list">
            <div>
              <div class="title">轻量化技术</div>
              <div class="p">基于视窗的轻量化数据化简方法，将无限的海量三维数据，化简为有限尺度的矢量数据</div>
            </div>
            <div>
              <div class="title">优化传输机制</div>
              <div class="p">多级分层的数据渐进传输机制，提升了服务器端和客户端数据传输效率和稳定性</div>
            </div>
            <div>
              <div class="title">一体化渲染引擎</div>
              <div class="p">GIS+BIM一体化渲染引擎的设计，真正实现了GIS+BIM场景融合渲染机制，实现了场景无缝切换和平滑漫游的用户体验</div>
            </div>
            <div>
              <div class="title">可视化交互式应用开发工具</div>
              <div class="p">可视化拖拽配置形式的应用开发搭建工具，从而极大降低了GIS+BIM三维可视化应用开发的技术难度，提升应用开发效率</div>
            </div>
          </div>
        </div>
      </div>
      <div class="application">
        <div class="module">
          <div class="productTitle">
            行业应用
            <span>/Application</span>
          </div>
          <div class="list">
            <div>
              智慧园区
              <div class="c">A</div>
            </div>
            <div>
              智慧建设
              <div class="c">B</div>
            </div>
            <div>
              智慧建筑
              <div class="c">C</div>
            </div>
            <div>
              运维管理
              <div class="c">D</div>
            </div>
            <div>
              智慧环保
              <div class="c">E</div>
            </div>
            <div>
              智慧安防
              <div class="c">F</div>
            </div>
            <div>
              智慧社区
              <div class="c">G</div>
            </div>
            <div>
              智慧场馆
              <div class="c">H</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile-product3">
      <div class="product-title">
        <div class="title-content">
          <div class="title">ZTMap3D</div>
          <div class="line"></div>
          <div class="p">
            GIS+BIM三维融合渲染平台
          </div>
          <div class="span">
            实现多架构的三维模型实时渲染基于最新的前端绘图技术开发解决三维渲染跨平台兼容性
          </div>
        </div>
        <div class="img">
          <img src="../../assets/images/index/banner_img3.png" alt="">
        </div>
      </div>
      <div class="part">
        <div class="part-title">概述</div>
        <div class="en-title">OVERVIEW</div>
        <div class="overview-content">
          臻图ZTMap系列轻量化三维融合渲染平台，实现了宏观二三维GIS地理信息、微观建筑物室内BIM模型的统一集成渲染和无缝漫游体验。创新的轻量化设计理念和开发架构，解决了从宏观到微观海量三维模型数据的加载和渲染效率难题，实现了空间数据的渐进加载和极速渲染功能，提供了良好的用户体验。该产品简便易用的交互式二次开发接口和可视化工具，极大缩短了三维可视化应用开发的周期、降低了可视化应用开发的门槛和成本。
        </div>
      </div>
      <div class="characteristics">
        <div class="part-title">功能简介</div>
        <div class="en-title">FUNCTION</div>
        <div class="content">
          <div class="item">
            <div>
              <p>01</p>
              <span>GIS二三维数据渲染支持</span>
            </div>
            <div>
              <p>02</p>
              <span>BIM数据渲染支持</span>
            </div>
            <div>
              <p>03</p>
              <span>GIS+BIM场景融合渲染</span>
            </div>
            <div>
              <p>04</p>
              <span>海量三维数据极速渲染</span>
            </div>
            <div>
              <p>05</p>
              <span>地理坐标&BIM坐标转换</span>
            </div>
            <div>
              <p>06</p>
              <span>GIS+BIM空间分析</span>
            </div>
            <div>
              <p>07</p>
              <span>三维特效模块组</span>
            </div>
            <div>
              <p>08</p>
              <span>可视化交互式开发工具</span>
            </div>
          </div>
        </div>
      </div>
      <div class="rendering">
        <div class="part-title">效果图</div>
        <div class="en-title">RENDERING</div>
        <div class="swiper">
          <el-carousel class="case-carousel" indicator-position="outside" height="23rem" >
            <el-carousel-item v-for=" index in 6" :key="index">
              <img :src="getImg(`product3-${index}.jpg`)" alt="Carousel Image" style="width: 100%; object-fit: contain;">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="part function">
        <div class="part-title">技术特点</div>
        <div class="en-title">CHARACTERISTICS</div>
        <div class="content">
          <div class="item" v-for="item in functionList" :key="item.id">
            <p>{{ item.title }}</p>
            <span>{{ item.content }}</span>
          </div>
        </div>
      </div>
      <div class="part">
        <div class="part-title">行业应用</div>
        <div class="en-title">APPLICATION</div>
        <div class="application-content">
          <div class="item item1">智慧园区</div>
          <div class="item item2">智慧建设</div>
          <div class="item item3">智慧建筑</div>
          <div class="item item4">运维管理</div>
          <div class="item item5">智慧环保</div>
          <div class="item item6">智慧安防</div>
          <div class="item item7">智慧社区</div>
          <div class="item item8">智慧场馆</div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: "Product3",
  metaInfo: {
    title:
      "三维融合渲染平台_GIS+BIM可视化_BIM轻量化_CIM平台可视化_ZTMap3D-上海臻图信息技术有限公司",
    meta: [
      {
        name: "keywords",
        content:
          "三维渲染,BIM可视化,GIS+BIM可视化,BIM轻量化,三维可视化,3D渲染,ThreeJS开发,三维模型渲染"
      },
      {
        name: "description",
        content:
          "ZTMap3D轻量化三维融合渲染平台,实现了宏观三维GIS地图、微观建筑物BIM模型的统一集成渲染和无缝漫游体验；支持高级负责三维渲染特效,可视化配置形式的应用开发搭建工具,极大降低了GIS+BIM三维可视化应用开发的技术难度。"
      }
    ]
  },
  data() {
    return {
      functionList: [
        {
          id: 1,
          title: '轻量化技术',
          content: '基于视窗的轻量化数据化简方法，将无限的海量三维数据，化简为有限尺度的矢量数据'
        },
        {
          id: 2,
          title: '优化传输机制',
          content: '多级分层的数据渐进传输机制，提升了服务器端和客户端数据传输效率和稳定性'
        },
        {
          id: 3,
          title: '一体化渲染引擎',
          content: 'GIS+BIM一体化渲染引擎的设计，真正实现了GIS+BIM场景融合渲染机制，实现了场景无缝切换和平滑漫游的用户体验'
        },
        {
          id: 4,
          title: '可视化交互式应用开发工具',
          content: '可视化拖拽配置形式的应用开发搭建工具，从而极大降低了GIS+BIM三维可视化应用开发的技术难度，提升应用开发效率'
        },
      ],
    };
  },
  methods: {
    getImg(fileName) {
      return require(`@/assets/images/product/${fileName}`);
    }
  },
  mounted: function() {}
};
</script>

<style lang="less" scoped>
//scoped
.productBanner {
  .img {
    background-image: url("../../assets/images/index/banner_img3.png");
  }
}
.product3 {
  .overview {
    margin-bottom: 100px;
  }
  .function {
    margin-top: 100px;
    .productTitle {
      text-align: center;
      margin-bottom: 40px;
    }
    .functionbg {
      background: url("../../assets/images/product/bg3.png") no-repeat top
        center / cover;
      .list {
        font-size: 0;
        padding-bottom: 68px;
        > div {
          display: inline-block;
          width: 25%;
          padding-top: 68px;
          vertical-align: top;
          .left {
            font-size: 40px;
            color: rgba(223, 223, 223, 1);
            float: left;
          }
          .right {
            padding-left: 60px;
            .title {
              font-size: 20px;
              color: rgba(75, 75, 75, 1);
              line-height: 46px;
              margin-bottom: 10px;
            }
          }
        }
      }
    }
  }
  .characteristics {
    height: 777px;
    background: url("../../assets/images/product/bg4.png") no-repeat top center /
      cover;
    overflow: hidden;
    margin-bottom: 100px;
    .productTitle {
      text-align: center;
      margin: 70px 0 40px 0;
    }
    .list {
      font-size: 0;
      > div {
        display: inline-block;
        width: 582px;
        height: 250px;
        background: #fff;
        margin-right: 24px;
        margin-bottom: 24px;
        box-shadow: 0px 0px 60px 10px rgba(13, 37, 62, 0.1);
        border-radius: 5px;
        text-align: center;
        vertical-align: top;
        padding: 0 50px;
        box-sizing: border-box;
        .title {
          font-size: 24px;
          color: rgba(2, 118, 247, 1);
          margin: 50px 0 20px 0;
        }
        .p {
          font-size: 20px;
          color: rgba(124, 124, 124, 1);
          line-height: 28px;
        }
        &:nth-child(2n) {
          margin-right: 0;
        }
      }
    }
  }
  .rendering {
    padding: 100px 0 150px 0;
    .productTitle {
      text-align: center;
      margin: 0 0 40px 0;
    }
    .list {
      font-size: 0;
      > div {
        width: 590px;
        height: 383px;
        background: #ccc;
        display: inline-block;
        margin-bottom: 20px;
        background: no-repeat center center / 100% 100%;
        &:nth-child(1) {
          background-image: url("../../assets/images/product/product3s-1.jpg");
        }
        &:nth-child(2) {
          background-image: url("../../assets/images/product/product3s-2.jpg");
        }
        &:nth-child(3) {
          background-image: url("../../assets/images/product/product3s-3.jpg");
        }
        &:nth-child(4) {
          background-image: url("../../assets/images/product/product3s-4.jpg");
        }
        &:nth-child(5) {
          background-image: url("../../assets/images/product/product3s-5.jpg");
        }
        &:nth-child(6) {
          background-image: url("../../assets/images/product/product3s-6.jpg");
        }
        &:nth-child(7) {
          background-image: url("../../assets/images/product/product3-7.jpg");
        }
        &:nth-child(2n + 1) {
          margin-right: 20px;
        }
        // &:last-child {
        //   margin: 0;
        //   width: 100%;
        // }
      }
    }
  }
  .application {
    margin-bottom: 127px;
    .productTitle {
      text-align: center;
      margin-bottom: 39px;
    }
    .list {
      font-size: 0;
      > div {
        width: 280px;
        height: 269px;
        display: inline-block;
        background: #ccc;
        margin-right: 26px;
        margin-bottom: 31px;
        vertical-align: top;
        writing-mode: lr-tb;
        font-size: 12px;
        padding: 42px 111px 0 144px;
        box-sizing: border-box;
        font-size: 30px;
        color: rgba(255, 255, 255, 1);
        line-height: 42px;
        cursor: pointer;
        position: relative;
        .c {
          position: absolute;
          font-size: 30px;
          line-height: 30px;
          bottom: 38px;
          left: 38px;
        }
        &:nth-child(4n) {
          margin-right: 0;
        }
        &:nth-child(1),
        &:nth-child(8) {
          background: url("../../assets/images/product/application_bg1.png")
            no-repeat center center/100% 100%;
          .c {
            color: #70b4ff;
          }
        }
        &:nth-child(2),
        &:nth-child(7) {
          background: url("../../assets/images/product/application_bg2.png")
            no-repeat center center/100% 100%;
          .c {
            color: #f895a4;
          }
        }
        &:nth-child(3),
        &:nth-child(6) {
          background: url("../../assets/images/product/application_bg3.png")
            no-repeat center center/100% 100%;
          .c {
            color: #ffd28e;
          }
        }
        &:nth-child(4),
        &:nth-child(5) {
          background: url("../../assets/images/product/application_bg4.png")
            no-repeat center center/100% 100%;
          .c {
            color: #a8efa3;
          }
        }
      }
    }
  }
}
.mobile-product3 {
  display: none;
  flex-direction: column;
  font-family: 'Normal';
  .product-title {
    width: 100%;
    height: 28rem;
    background: linear-gradient(180deg, #3374EF 0%, #9DCFFF 100%);
    box-sizing: border-box;
    padding: 8rem 0 0 2rem;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    color: white;
    .title-content {
      .title {
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
      }
      .line {
        width: 4rem;
        height: 0.2rem;
        background: #FFFFFF;
        margin-top: 1rem;
      }
      .p {
        font-size: 1.4rem;
        font-weight: 500;
        line-height: 2rem;
        margin-top: 2rem;
      }
      .span {
        width: 15rem;
        margin-top: 1rem;
        font-size: 1rem;
        font-weight: 350;
        line-height: 1.6rem;
      }
    }
    .img {
      flex-grow: 1;
      img {
        width: 100%;
        object-fit: contain;
      }
    }
  }
  .part {
    box-sizing: border-box;
    padding: 2rem;
    text-align: center;
    font-family: 'Normal';
    .part-title {
      font-size: 1.8rem;
      font-weight: bold;
      line-height: 3rem;
      color: #333;
    }
    .en-title {
      font-size: 1.4rem;
      font-weight: 350;
      line-height: 2rem;
      color: #999;
    }
  }
  .part {
    box-sizing: border-box;
    padding: 2rem;
    text-align: center;
    font-family: 'Normal';
    .overview-title {
      font-size: 1.8rem;
      font-weight: bold;
      line-height: 3rem;
      color: #333;
    }
    .en-title {
      font-size: 1.4rem;
      font-weight: 350;
      line-height: 2rem;
      color: #999;
    }
    .overview-content {
      font-size: 1rem;
      font-weight: 350;
      line-height: 2rem;
      color: #3D3D3D;
      text-align: left;
      text-indent: 2em;
      margin-top: 2rem;
      color: #333333;
    }
  }
  .function {
    background-image: url('../../assets/images/product/bg1.png');
    background-position: left;
    background-repeat: no-repeat;
    background-size: cover;
    .content {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      box-sizing: border-box;
      .item {
        width: 47.5%;
        box-sizing: border-box;
        padding: 2rem 1.5rem 1.5rem 1.5rem;
        background: rgba(255, 255, 255, 0.5);
        font-family: 'Normal';
        margin-top: 1.5rem;
        text-align: left;
        >p {
          font-size: 1.4rem;
          font-weight: bold;
          line-height: 2rem;
          text-align: center;
        }
        >span {
          font-size: 1rem;
          font-weight: 350;
          line-height: 1.5rem;
          margin-top: 2rem;
          color: #333333;
          
        }
      }
    }
  }
  .rendering {
    text-align: center;
    font-family: 'Normal';
    box-sizing: border-box;
    padding: 2rem 0;
    .part-title {
      font-size: 1.8rem;
      font-weight: bold;
      line-height: 3rem;
      color: #333;
    }
    .en-title {
      font-size: 1.4rem;
      font-weight: 350;
      line-height: 2rem;
      color: #999;
    }
    .swiper {
      margin-top: 2rem;
    }
  }
  .characteristics {
    background-image: url('../../assets/images/product/bg1.png');
    background-position: left;
    background-repeat: no-repeat;
    background-size: cover;
    text-align: center;
    font-family: 'Normal';
    box-sizing: border-box;
    padding: 2rem;
    height: 25rem;
    .part-title {
      font-size: 1.8rem;
      font-weight: bold;
      line-height: 3rem;
      color: #333;
    }
    .en-title {
      font-size: 1.4rem;
      font-weight: 350;
      line-height: 2rem;
      color: #999;
    }
    .content {
      width: 100%;
      box-sizing: border-box;
      padding-top: 2rem;
      display: flex;
      flex-wrap: wrap;
      .item {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        box-sizing: border-box;
        padding: 0 0.5rem;
        margin-top: 1rem;
        div {
          width: 50%;
          display: flex;
          align-items: center;
          >p {
            font-size: 1.2rem;
            font-weight: bold;
            color: #999999;
          }
          >span {
            margin-left: 1rem;
            font-size: 1rem;
            font-weight: 350;
            color: #333333;
          }
        }
      }
    }
  }
  .part {
    .application-content {
      width: 100%;
      height: 25rem;
      margin-top: 2rem;
      font-family: 'Normal';
      position: relative;
      margin-left: -1rem;
      .item {
        width: 9.5rem;
        height: 9.5rem;
        clip-path: polygon(25% 0%, 75% 0%, 100% 44%, 75% 88%, 25% 88%, 0% 44%);
        font-size: 1.4rem;
        font-weight: bold;
        line-height: 8.36rem;
        text-align: center;
        color: #fff;
      }
      .item1 {
        background: rgba(60, 128, 232, 0.5);
        position: absolute;
        top: 0;
        left: 0;
      }
      .item2 {
        background: rgba(60, 128, 232, 0.8);
        position: absolute;
        top: 0;
        left: 50%;
      }
      .item3 {
        background: rgba(60, 128, 232, 0.6);
        position: absolute;
        top: 20%;
        left: 25%;
      }
      .item4 {
        background: rgba(60, 128, 232, 0.7);
        position: absolute;
        top: 20%;
        left: 75%;
      }
      .item5 {
        background: rgba(60, 128, 232, 0.4);
        position: absolute;
        top: 37.5%;
        left: 0%;
      }
      .item6{
        background: rgba(60, 128, 232, 0.5);
        position: absolute;
        top: 37.5%;
        left: 50%;
      }
      .item7 {
        background: rgba(60, 128, 232, 0.7); 
        position: absolute;
        top: 57.5%;
        left: 25%; 
      }
      .item8 {
        background: rgba(60, 128, 232, 0.8); 
        position: absolute;
        top: 57.5%;
        left: 75%; 
      }
    }
  }
}
/deep/.el-carousel__indicators--horizontal  {
  width:100% !important;
  text-align: center !important;
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
/deep/ .el-carousel__button {
  width: 0.5rem;
  height: 0.4rem;
  background: #C1E1FF;
}
/deep/ .case-carousel {
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
@media (max-width: 1024px) {
  .productBanner {
    display: none !important;
  }
  .product3 {
    display: none;
  }
  .mobile-product3 { 
    display: flex !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/product/Product3.vue